export default __webpack_public_path__ + "static/media/create.acac7abd.svg";